import React from 'react'
import { usePostRequest } from '../hooks/request'
import { useMessage } from '../hooks/message'
import DueForm from './DueForm'
import { DUE_LIST } from '../urls'

export default function DueCreate({ onSuccess, onCancel }) {
    const brandCreate = usePostRequest({ url: DUE_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success } = await brandCreate.request({ data })

        if (success) {
            showMessage('Успешно сохранен', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered"><b>Добавить</b></h1>

            <DueForm
                loading={brandCreate.loading}
                onSubmit={onSubmit}
                onCancel={onCancel} />
        </div>
    )
}
